import { gql } from '@urql/core'

export const queryCriteriaGroupConfigs = gql`
  query (
    $criteriaGroupConfigCondition: criteria_group_config_bool_exp
    $offset: Int!
    $limit: Int!
    $orderBy: [criteria_group_config_order_by!]
  ) {
    criteria_group_config(where: $criteriaGroupConfigCondition, offset: $offset, limit: $limit, order_by: $orderBy) {
      id
      names
      code
      group_processes
      group_active
      criteria_group_deletability {
        is_deletable
      }
    }
    criteria_group_config_aggregate(where: $criteriaGroupConfigCondition, order_by: $orderBy) {
      aggregate {
        count
      }
    }
  }
`

export const queryCriteriaGroupById = gql`
  query ($groupId: Int!) {
    criteria_group_config(where: { id: { _eq: $groupId } }) {
      id
      names
      group_processes
      group_active
      criteria_types
    }
  }
`

export const queryCriteriaGroupsByProcessesSortedByStatusAndId = gql`
  query ($processes: jsonb!) {
    criteria_group_config(
      where: { group_processes: { _contained_in: $processes } }
      order_by: [{ group_active: desc }, { id: asc }]
    ) {
      id
      names
      group_processes
      group_active
      criteria_types
    }
  }
`

export const insertCriteriaGroupConfig = gql`
  mutation ($criteriaGroupInsertInput: [criteria_group_config_insert_input!]!) {
    insert_criteria_group_config(objects: $criteriaGroupInsertInput) {
      affected_rows
    }
  }
`

export const updateCriteriaGroupConfigAndRelatedEvaluationCriteriaByGroupId = gql`
  mutation (
    $groupId: Int!
    $criteriaGroupFieldsSetClause: criteria_group_config_set_input!
    $criteriaConfigFieldsSetClause: criteria_config_set_input!
  ) {
    update_criteria_group_config(where: { id: { _eq: $groupId } }, _set: $criteriaGroupFieldsSetClause) {
      affected_rows
    }
    update_criteria_config(where: { criteria_group_id: { _eq: $groupId } }, _set: $criteriaConfigFieldsSetClause) {
      affected_rows
    }
  }
`

export const fetchProcessCriteriaSorted = gql`
  query fetchProcessCriteriaSorted(
    $criteriaGroupWhereClause: criteria_group_sorting_config_bool_exp!
    $criteriaWhereClause: criteria_sorting_config_bool_exp!
  ) {
    criteria_group_sorting_config(where: $criteriaGroupWhereClause, order_by: [{ sort_order: asc }]) {
      id
      application_type_id
      group_id
      process
      level
      sort_order
      criteria_type
      criteria_group_config {
        code
        id
        group_active
        names
        group_processes
        criteria_sorting_configs(where: $criteriaWhereClause, order_by: [{ sort_order: asc }]) {
          id
          application_type_id
          group_id
          process
          level
          sort_order
          criteria_id
          criteria_type
          group_id
          criteria_config {
            active
            id
            criteria_id
            criteria_group_id
            code
            processes
            description
          }
        }
      }
    }
  }
`

export const updateSortOnCriteriaGroupConfig = gql`
  mutation UpdateTwoCriteriaGroupSortConfig(
    $firstWhere: criteria_group_sorting_config_bool_exp!
    $secondWhere: criteria_group_sorting_config_bool_exp!
    $setClause1: criteria_group_sorting_config_set_input!
    $setClause2: criteria_group_sorting_config_set_input!
  ) {
    updateFirst: update_criteria_group_sorting_config(where: $firstWhere, _set: $setClause1) {
      affected_rows
    }
    updateSecond: update_criteria_group_sorting_config(where: $secondWhere, _set: $setClause2) {
      affected_rows
    }
  }
`

export const updateSortOnCriteriaConfig = gql`
  mutation UpdateTwoCriteriaSortConfig(
    $firstWhere: criteria_sorting_config_bool_exp!
    $secondWhere: criteria_sorting_config_bool_exp!
    $setClause1: criteria_sorting_config_set_input!
    $setClause2: criteria_sorting_config_set_input!
  ) {
    updateFirst: update_criteria_sorting_config(where: $firstWhere, _set: $setClause1) {
      affected_rows
    }
    updateSecond: update_criteria_sorting_config(where: $secondWhere, _set: $setClause2) {
      affected_rows
    }
  }
`

export const queryCriteriaConfigs = gql`
  query (
    $criteriaConfigCondition: criteria_config_bool_exp
    $offset: Int!
    $limit: Int!
    $orderBy: [criteria_config_order_by!]
  ) {
    criteria_config(where: $criteriaConfigCondition, offset: $offset, limit: $limit, order_by: $orderBy) {
      id
      criteria_id
      description
      criteria_type
      processes
      active
      criteria_deletability {
        is_deletable
      }
    }
    criteria_config_aggregate(where: $criteriaConfigCondition, order_by: $orderBy) {
      aggregate {
        count
      }
    }
  }
`

export const queryCriteriaConfigById = gql`
  query ($criteriaId: Int!) {
    criteria_config(where: { id: { _eq: $criteriaId } }) {
      id
      criteria_type
      criteria_id
      active
      criteria_group_id
      description
      processes
      application_type_ids
      levels
    }
  }
`

export const insertCriteriaConfig = gql`
  mutation ($criteriaConfigInsertInput: [criteria_config_insert_input!]!) {
    insert_criteria_config(objects: $criteriaConfigInsertInput) {
      affected_rows
    }
  }
`

export const updateCriteriaConfigById = gql`
  mutation ($criteriaId: Int!, $criteriaConfigFieldsSetClause: criteria_config_set_input!) {
    update_criteria_config(where: { id: { _eq: $criteriaId } }, _set: $criteriaConfigFieldsSetClause) {
      affected_rows
    }
  }
`

export const deleteCriteriaGroupConfigById = gql`
  mutation ($groupId: Int!) {
    delete_criteria_group_config(where: { id: { _eq: $groupId } }) {
      affected_rows
    }
  }
`

export const deleteCriteriaConfigById = gql`
  mutation ($criteriaId: Int!) {
    delete_criteria_config(where: { id: { _eq: $criteriaId } }) {
      affected_rows
    }
  }
`
